import React from "react";

function FlexibilityIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M40.61 38.553H16.608a1.44 1.44 0 000 2.879H40.61a1.44 1.44 0 000-2.88zM16.41 31.44l12.04 2.3a1.424 1.424 0 00.354-.005l11.982-2.29a1.434 1.434 0 10-.374-2.845c-.062.004-11.764 2.283-11.819 2.27l-11.828-2.274a1.442 1.442 0 00-1.593 1.425 1.42 1.42 0 001.238 1.42z"
            ></path>
            <path
                fill="#fff"
                d="M40.45 33.395l-11.79 1.31a.389.389 0 01-.105 0l-11.79-1.31a1.434 1.434 0 00-.317 2.85l12.001 1.334c.105.012.211.012.317 0l12-1.334a1.434 1.434 0 00-.316-2.85zM28.244 28.788a.48.48 0 00.73 0l2.878-3.36a.483.483 0 00-.364-.79h-.96V16.96a.963.963 0 00-.96-.96H27.65a.963.963 0 00-.96.96v7.677h-.96a.484.484 0 00-.364.792l2.879 3.359z"
            ></path>
        </svg>
    );
}

export default FlexibilityIcon;
